//import { useTranslate } from "react-admin";

/**
 * Coupon
 *
 * Note** QTY is unknown
 */
class Coupon {
  constructor({ id, type = "Undefined", logic, value, varName, qty = 1 }) {
    this.id = id;
    this.type = type;
    this.logic = logic;
    this.value = value;
    this.qty = qty;
    this.varName = varName;
  }

  clone() {
    return new Coupon({
      id: this.id,
      type: this.type,
      logic: this.logic,
      value: this.value,
      qty: this.qty,
      varName: this.varName,
    });
  }

  getMessage(lan = "th-TH") {
    if (lan.includes("th")) lan = "th-TH";
    if (lan.includes("en")) lan = "en-US";
    if (this.type === "Undefined") return "";
    if (!CouponTextMap[this.type][lan]) lan = "en-US";
    if (this.value === 0) return "";
    return CouponTextMap[this.type][lan].replace("[value]", this.value);
  }

  getTierMessage(lan = "th-TH") {
    if (this.type === "Undefined") return "";
    if (lan.includes("th")) lan = "th-TH";
    if (lan.includes("en")) lan = "en-US";
    if (this.type === "Discount") {
      if (!CouponTextMap["Tier Discount"][lan]) lan = "en-US";
      return CouponTextMap["Tier Discount"][lan].replace("[value]", this.value);
    } else if (this.type === "Discount Percent") {
      if (!CouponTextMap["Tier Discount Percent"][lan]) lan = "en-US";
      return CouponTextMap["Tier Discount Percent"][lan].replace(
        "[value]",
        this.value
      );
    } else {
      if (!CouponTextMap[this.type][lan]) lan = "en-US";
      return CouponTextMap[this.type][lan].replace("[value]", this.value);
    }
  }

  /**
   * For display in cart or receipt
   */
  getRawMessage(locale = "th") {
    if (this.type === "Undefined") return "";

    if (this.type === "Discount") {
      return `- ${this.value}`;
    } else if (this.type === "Discount Percent") {
      return `- ${this.value}%`;
    } else if (this.type === "Reward") {
      if (locale.includes("th")) return `+${this.value} แต้ม`;
      else return `+${this.value} points`;
    } else if (this.type === "Multiplier") {
      return `+ ${this.value}%`;
    } else {
      return this.value;
    }
  }

  /**
   *
   * @returns Message For display in Cart
   */
  getDiscountNumber(totalPrize) {
    const exactType = this.type;

    if (exactType === "Discount") {
      return this.value;
    } else if (exactType === "Discount Percent") {
      //mock percent coupon
      return Math.floor((totalPrize * this.value) / 100);
    } else if (exactType === "Reward") {
      return 0;
    } else if (exactType === "Multiplier") {
      return 0;
    }
    return `Not support type:[${exactType}]`;
  }

  getEarnPointNumber(finalPoint) {
    const exactType = this.type;

    if (exactType === "Discount") {
      return finalPoint;
    } else if (exactType === "Discount Percent") {
      //mock percent coupon
      return finalPoint;
    } else if (exactType === "Reward") {
      return finalPoint + this.value;
    } else if (exactType === "Multiplier") {
      return finalPoint * this.value;
    }
    return `Not support type:[${exactType}]`;
  }

  getPayloadData(pricebeforeDiscount, lan = "th-TH") {
    const exactType = this.type;

    if (exactType === "Discount") {
      return {
        type: "discount",
        id: this.id,
        coupon_id: this.id,
        qty: this.qty,
        discount_amount: -this.value,
        shortDesc: `${this.getMessage(lan)}`,
        desc: `${this.getMessage(lan)}`, //For display in cart
        descValue: `${-this.value}`, //For display in cart
      };
    } else if (exactType === "Discount Percent") {
      const discountAmount = -Math.floor(
        (pricebeforeDiscount * this.value) / 100
      );
      return {
        ///type: this.type,
        type: "discount",
        id: this.id,
        coupon_id: this.id,
        qty: this.qty,
        discount_amount: discountAmount,
        discount_percent: -Number(this.value),
        shortDesc: `${this.getMessage(lan)}`,
        desc: `${this.getMessage(lan)}`, //For display in cart
        descValue: `THB ${discountAmount}`, //For display in cart
      };
    } else if (exactType === "Multiplier") {
      return {
        type: "multiplier",
        id: this.id,
        coupon_id: this.id,
        qty: this.qty,
        logic: this.logic.replace(`[${this.varName}]`, this.value),
        shortDesc: `${this.getMessage(lan)}`, //For normal discount
        desc: `${this.getMessage(lan)}`, //For display in cart
        descValue: ``, //For display in cart
      };
    } else if (exactType === "Reward") {
      return {
        type: "reward",
        id: this.id,
        coupon_id: this.id,
        qty: this.qty,
        earn: {
          type: "Reward",
          amount: this.value,
        },
        earn_amount: this.value,
        shortDesc: `${this.getMessage(lan)}`, //For normal discount
        desc: `${this.getMessage(lan)}`, //For display in cart (Privilege)
        descValue: ``, //For display in cart
      };
    } else
      return {
        id: this.id,
        coupon_id: this.id,
        type: this.type,
        logic: this.logic,
        value: this.value,
        qty: this.qty,
        desc: `Coupon`, //For display in cart
        descValue: `${this.value}`, //For display in cart
      };
  }
}

const CouponTextMap = {
  Discount: {
    "th-TH": `ลด [value] บาท`,
    "en-US": `Discount THB[value]`,
  },

  "Discount Percent": {
    "th-TH": `ลด [value]%`,
    "en-US": `Discount [value]%`,
  },

  "Tier Discount Percent": {
    "th-TH": `[value]%`,
    "en-US": `[value]%`,
  },

  "Tier Discount": {
    "th-TH": `[value] บาท`,
    "en-US": `THB[value]`,
  },

  Reward: {
    "th-TH": `+[value] คะแนน`,
    "en-US": `+[value] points`,
  },
  Multiplier: {
    "th-TH": `x[value] คะแนน`,
    "en-US": `x[value] points`,
  },
};

export default Coupon;
